<template>
    <div class="d-flex flex-column gap-12 mb-6">
        <divcard>
            <div class="card">
                <div class="card-part pt-0 px-6 py-4">
                    <div class="d-flex justify-space-between">
                        <div class="txt-head black--text mb-2">
                            <span class="theme-color-one">ส่วนที่ 3 :</span> การประเมิน
                        </div>
                        <Button theme="6" @onClick="addEval">
                            + บันทึกการประเมิน
                        </Button>
                    </div>
                    <div>
                        <div class="d-flex justify-space-between mb-3 mt-3 px-6">
                            <div v-for="(item, i) in tableHeader" :key="i" :style="{ 'width': item.width }"
                                :class="['text-' + (item.align ? item.align : 'start')]">
                                {{ item.name }}
                            </div>
                        </div>
                        <div class="list-layout ">
                            <TechEvalItemExpand v-for="(item, i) in data" :key="i" :item="item" :index="i"
                                :headers="headers" @onUpdateStatus="(status) => onUpdateStatus(status, item.id)">
                            </TechEvalItemExpand>
                        </div>
                    </div>
                 
                </div>
            </div>
        </divcard>
    </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import TechEvalItemExpand from "../../../components/TechEvalItemExpand"
import Button from "../../../components/input/Button"
import { eventBus, validateEmail } from "../../../plugins/global-funcs"
import { mapState } from "vuex"
import SelectBox from "../../../components/input/SelectBox";

export default {
    name: "Tccl3",
    components: {
        TextField,
        SelectBox,
        SwitchInset,
        Button,
        AutoBox,
        TechEvalItemExpand
    },
    props: {
    },
    data() {
        return {
            form: {},
            data: [
                {
                    no: 1,
                    projectCode: "PRJ-001",
                    projectName: "1",
                    fiscalYear: "1",
                    plan: "1",
                    researcher: "1",
                    budget: "1",
                    incashPercent: "1",
                    recordedDate: "1",
                    status: "1",
                },
            ],
            tableHeader: [
                {
                    name: 'จัดการ',
                    width: '7%',
                    align: 'center'

                },
                {
                    name: 'วันที่ประเมิน',
                    width: '10%',
                    align: 'center'
                },
                {
                    name: 'ผู้บันทึก / ผู้ประเมิน',
                    width: '30%',
                    align: 'left'
                },
                {
                    name: 'TRL',
                    width: '9%',
                    align: 'center'
                },
                {
                    name: 'TPL',
                    width: '9%',
                    align: 'center'
                },
                {
                    name: 'FEAST',
                    width: '9%',
                    align: 'center'
                },
                {
                    name: 'P2MP',
                    width: '9%',
                    align: 'center'
                },
                {
                    name: 'Preview',
                    width: '9%',
                    align: 'center'
                },
                {
                    name: '',
                    width: '8%',
                    align: 'center'
                },

            ],
            headers: [
                { text: "ลำดับ", value: "index", width: "7%", align: "center" },
                { text: "รหัสโครงการ", value: "projectCode", width: "10%", align: "center" },
                { text: "ชื่อโครงการ", value: "projectName", width: "30%", align: "left" },
                { text: "นักวิจัย", value: "researcher", width: "9%", align: "left" },
                { text: "งบประมาณ", value: "budget", width: "9%", align: "center" },
                { text: "%Incash", value: "incashPercent", width: "9%", align: "center" },
                { text: "วันที่บันทึก", value: "recordedDate", width: "9%", align: "center" },
                { text: "สถานะ", value: "status", width: "9%", align: "center" },
                { text: "exp", value: "status", width: "8%", align: "center" },
            ],
            monthList: [
            ],
            doNotSubmit: false,
        }
    },
    computed: {
        ...mapState({
            GeneralForm: state => state.Tccl.GeneralForm,
        })
    },
    methods: {
        addEval() {

        }
    }

}
</script>

<style lang="scss" scoped></style>